import styled from "styled-components";
import assests from "../../ui/assests";

export const ListWrapper = styled.ul`
  margin: 45px 0 30px;
  @media (max-width: 1199px) {
    margin: 25px 0;
  }
  @media (max-width: 899px) {
    margin: 20px 0;
  }
  li {
    position: relative;
    padding-left: 35px;
    font-family: "Poppins";
    font-weight: 300;
    font-size: 16px;
    line-height: 1.69;
    color: rgb(44, 44, 44);
    @media (max-width: 599px) {
      padding-left: 27px;
    }
    &:not(:last-child) {
      margin-bottom: 12px;
      @media (max-width: 599px) {
        margin-bottom: 3.7px;
      }
    }
    &::before {
      content: "";
      position: absolute;
      top: 1px;
      left: 0;
      width: 27px;
      height: 27px;
      background: url(${assests.ListCheckIcon}) no-repeat center;
      background-size: cover;
      @media (max-width: 599px) {
        top: 4px;
        width: 20px;
        height: 20px;
      }
    }
  }
`;

export const CommonBtnWrapStyled = styled.div`
  filter: url(#goo);
  display: inline-block;
  .common-button {
    color: rgb(255, 255, 255);
    font-size: 17px;
    font-weight: 700;
    text-decoration: none;
    display: inline-flex;
    position: relative;
    &:hover {
      .common-button-text {
        &::before {
          -webkit-transform: translateY(-50%) translateX(7px);
          -ms-transform: translateY(-50%) translateX(7px);
          transform: translateY(-50%) translateX(7px);
        }
      }
      .common-button-arrow {
        -webkit-transform: translateX(10px);
        -ms-transform: translateX(10px);
        transform: translateX(10px);
        &::before {
          -webkit-transform: translateY(-50%) translateX(-7px);
          -ms-transform: translateY(-50%) translateX(-7px);
          transform: translateY(-50%) translateX(-7px);
        }
      }
    }
    .common-button-text {
      background-color: rgb(254, 15, 86);
      border-radius: 30px;
      justify-content: center;
      align-items: center;
      padding: 17px 26px;
      display: flex;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        width: 20px;
        height: 10px;
        background-color: rgb(254, 15, 86);
        border-radius: 10px;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        -webkit-transition: -webkit-transform 1s ease;
        transition: -webkit-transform 1s ease;
        -o-transition: transform 1s ease;
        transition: transform 1s ease;
        transition:
          transform 1s ease,
          -webkit-transform 1s ease;
        z-index: -1;
      }
    }
    .common-button-arrow {
      pointer-events: auto;
      background-color: rgb(254, 15, 86);
      border-radius: 60px;
      justify-content: center;
      align-items: center;
      width: 61px;
      height: 61px;
      transition: all 0.5s cubic-bezier(0.445, 0.05, 0.55, 0.95);
      display: flex;
      position: relative;
      transform: translate(14px);
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 20px;
        height: 10px;
        background-color: rgb(254, 15, 86);
        border-radius: 10px;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        -webkit-transition: -webkit-transform 1s ease;
        transition: -webkit-transform 1s ease;
        -o-transition: transform 1s ease;
        transition: transform 1s ease;
        transition:
          transform 1s ease,
          -webkit-transform 1s ease;
        z-index: -1;
      }
    }
    .btn-embeded {
      display: none;
    }
  }
`;
